import {SanityPageBase} from '@/types/Sanity'
import {BLOG_DIR} from './env'

export default function resolveUrl(
  page?: SanityPageBase,
  {
    base = true,
    params,
  }: {
    base?: boolean
    params?: string
  } = {},
) {
  const segment =
    page?._type === 'blog.post' || page?._type === 'blog.video' ? `/${BLOG_DIR}/` : '/'
  const lang = ''
  const slug = page?.metadata?.slug?.current
  const path = slug === 'index' ? null : slug

  return [base && process.env.NEXT_PUBLIC_BASE_URL, lang, segment, path, params]
    .filter(Boolean)
    .join('')
}

export const resolvePostUrlFromPreview = (args: {
  slug: string | undefined
  mainCategorySlug: string | undefined
  clusterSlug: string | undefined
}) => {
  const {slug, mainCategorySlug, clusterSlug} = args
  return [BLOG_DIR, clusterSlug, mainCategorySlug, slug].filter(Boolean).join('/')
}
